import React, { useState } from 'react';
import ReactHtmlParser from '@orrisroot/react-html-parser';

import tickCircleGreen from 'assets/images/button/tick-circle-solid-green.svg';
import { CoverItem } from 'types/expiryRenewal';
import CoverItemModal from './CoverItemModal';

type IncludedAddOnProps = {
  header?: string;
  body?: string;
  modal?: CoverItem['modal'];
};

// An add-on already part of the member's cover, so it reads as settled rather than selectable.
const IncludedAddOn = ({ header, body, modal }: IncludedAddOnProps) => {
  const [toggleInfo, setToggleInfo] = useState(false);

  return (
    <div
      className="d-flex align-items-start gap-3 rounded p-3 mb-3"
      style={{ background: '#e6f4ea', border: '1px solid #2f855a' }}
      data-testid="included-addon"
    >
      <img src={tickCircleGreen} alt="" width="24" height="24" className="flex-shrink-0" />
      <div>
        <h5 className="mb-1">{header}</h5>
        {ReactHtmlParser(body ?? '')}
        {modal?.link && (
          <>
            <button
              type="button"
              className="btn btn-link text-link p-0 border-0 align-baseline shadow-none"
              onClick={() => setToggleInfo(true)}
            >
              {modal?.link}
            </button>
            {toggleInfo && (
              <CoverItemModal modal={modal} onClose={() => setToggleInfo(false)} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default IncludedAddOn;
